module.exports = __webpack_public_path__ + "img/375_nav_img2.9434e788.png";